import RouteNameEnum from "./RouteNameEnum"
import RoutePathEnum from "./RoutePathEnum"
import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: RoutePathEnum.Flight,
        name: RouteNameEnum.Flight,
        component: () =>
            import(
                 /* webpackChunkName: "options" */  '@/pages/FlightResultsPage/v2/FlightResultsPage.vue'

            ),
    },
    {
        path: RoutePathEnum.Train,
        name: RouteNameEnum.Train,
        component: () =>
            import(
                /* webpackChunkName: "options" */ '@/pages/TrainResultsPage/v2/TrainResultsPage.vue'
            ),
    },
    {
        path: RoutePathEnum.Transfer,
        name: RouteNameEnum.Transfer,
        component: () =>
            import(
                /* webpackChunkName: "options" */     '@/pages/TransferPage/v2/TransferPage.vue'

            ),
    },
    {
        path: RoutePathEnum.PaymentV2,
        name: RouteNameEnum.PaymentV2,
        component: () =>
            import(
                /* webpackChunkName: "payment" */ '@/pages/PaymentPage/v2/PaymentPage.vue'
            ),
        meta: { requiresAuth: true }
    },
    {
        path: RoutePathEnum.OptionsV2,
        name: RouteNameEnum.OptionsV2,
        component: () =>
            import(
                /* webpackChunkName: "options" */ '@/pages/OptionsPage/v2/OptionsPage.vue'
            ),
    },


    {
        path: RoutePathEnum.UserInfoV2,
        name: RouteNameEnum.UserInfoV2,
        component: () =>
            import(
                /* webpackChunkName: "user-info" */ '@/pages/UserInfoPage/v2/UserInfoPage.vue'
            ),
    },

    {
        path: RoutePathEnum.Success,
        name: RouteNameEnum.Success,
        component: () =>
            import(
                /* webpackChunkName: "success" */ '@/pages/ConfirmationPage/v2/ConfirmationPage.vue'
            ),
        meta: { requiresAuth: true }
    },
    {
        path: RoutePathEnum.Paid,
        name: RouteNameEnum.Paid,
        component: () =>
            import(
                /* webpackChunkName: "paid" */ '@/pages/PaidPage/v1/PaidPage.vue'
            ),
        meta: { requiresAuth: true }
    },
    {
        path: RoutePathEnum.Error,
        name: RouteNameEnum.Error,
        component: () =>
            import(
                /* webpackChunkName: "error" */ '@/pages/ErrorPage/v2/ErrorPage.vue'
            ),
        meta: { requiresAuth: false }
    },
    {
        path: RoutePathEnum.NewPassword,
        name: RouteNameEnum.NewPassword,
        component: () =>
            import(
                /* webpackChunkName: "new-password" */ '@/pages/NewPasswordPage/v2/NewPasswordPage.vue'
            ),
    },
    {
        path: RoutePathEnum.BalancePayment,
        name: RouteNameEnum.BalancePayment,
        component: () =>
            import(
                /* webpackChunkName: "balance-payment" */ '@/pages/BalancePaymentPage/v2/BalancePaymentPage.vue'
            ),
        meta: { requiresAuth: false }
    },
    {
        path: RoutePathEnum.WidgetCartSuccess,
        name: RouteNameEnum.WidgetCartSuccess,
        component: () =>
            import(
                /* webpackChunkName: "widget-cart-success" */ '@/pages/WidgetCartSuccessPage/v1/WidgetCartSuccessPage.vue'
            ),
        meta: { requiresAuth: true }
    },

]

export default routes